<template>
  <div class="message">
    <div class="icon">{{ icon }}</div>
    <span>{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'MessageScreen',
  props: [
    'icon',
    'message',
  ],
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.message {
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  .icon {
    color: $secondary-text;
    font-size: 15rem;
    height: 15rem;
    line-height: 15rem;
    width: 15rem;
  }

  span {
    color: $secondary-text;
    font-size: 2rem;
    margin-top: 2rem;
  }
}
</style>
